module.exports = __webpack_public_path__ + "img/7.ba35c6cf.jpg";